import React, { useState } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";
import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const css = {
  root: {
    width: "100%",
    marginTop: 18
  },
  optionButton: {
    display: "block",
    width: "100%",
    textAlign: "left",
    padding: "12px 14px",
    border: "1px solid",
    borderColor: "#ddd",
    backgroundColor: "#fff",
    marginBottom: 8
  },
  selected: {
    borderColor: "#222",
    backgroundColor: "#f7f7f7"
  }
};

const MajorTypography = withStyles({
  root: { fontSize: 14, fontWeight: 700, color: "#222" }
})(Typography);
const MinorTypography = withStyles({
  root: { marginTop: 4, fontSize: 12, color: "#777" }
})(Typography);

ChangeItemVisibilityModalView.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onItemOpenPresetSubmit: PropTypes.func.isRequired,
  isItemListPublic: PropTypes.bool.isRequired
};

function ChangeItemVisibilityModalView(props) {
  const { open, onClose, onItemOpenPresetSubmit, isItemListPublic } = props;
  const [isPublic, setIsPublic] = useState(isItemListPublic);

  const handleClick = value => () => {
    if (value === "public") {
      setIsPublic(true);
    } else {
      setIsPublic(false);
    }
  };

  const getModalContent = () => {
    return (
      <div style={css.root}>
        <ButtonBase
          style={{ ...css.optionButton, ...(isPublic ? css.selected : {}) }}
          onClick={handleClick("public")}
        >
          <MajorTypography>
            <TXT name="msg_publicItem" />
          </MajorTypography>
          <MinorTypography>
            <TXT name="msg_publicItemDetail" />
          </MinorTypography>
        </ButtonBase>
        <ButtonBase
          style={{ ...css.optionButton, ...(!isPublic ? css.selected : {}) }}
          onClick={handleClick("private")}
        >
          <MajorTypography>
            <TXT name="msg_privateItem" />
          </MajorTypography>
          <MinorTypography>
            <TXT name="msg_privateItemDetail" />
          </MinorTypography>
        </ButtonBase>
      </div>
    );
  };

  const handleSubmit = async () => {
    await onItemOpenPresetSubmit(isPublic);
  };

  return (
    <CommonModalView
      open={open}
      onClose={onClose}
      titleText={<TXT name="titleModal_setItemVisibility" />}
      contentComponent={getModalContent()}
      firstButtonText={<TXT name="btnModal_cancel" />}
      firstButtonFunc={onClose}
      secondButtonText={<TXT name="btnModal_save" />}
      secondButtonFunc={handleSubmit}
    />
  );
}

export default ChangeItemVisibilityModalView;
